import React, { useEffect, useState } from "react";
import {
  Box, Button, Flex, Table, Tbody, Td, Th, Thead, Tr, Text, useToast, Spinner, Badge,
} from "@chakra-ui/react";
import { getDeadLetters, requeueDeadLetter } from "../../utils/apis/agentApi";

/** Agent dead-letter queue: inbound messages that failed repeatedly, with a
 *  one-click requeue. Ported from the agent's HTML admin. */
const DeadLetters = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const load = async () => {
    setLoading(true);
    const res = await getDeadLetters(200);
    if (res.ok && res.data) setRows(res.data.dead_letters || []);
    else toast({ title: res.status === 502 ? "Agent unreachable" : "Failed to load",
      status: "error", duration: 3000, isClosable: true });
    setLoading(false);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const requeue = async (id: number) => {
    const res = await requeueDeadLetter(id);
    if (res.ok) { toast({ title: "Requeued", status: "success", duration: 2000 }); load(); }
    else toast({ title: "Requeue failed", status: "error", duration: 3000 });
  };

  return (
    <Box p={5}>
      <Flex justifyContent="space-between" mb={4} alignItems="flex-start">
        <Box>
          <Text fontSize="xl" fontWeight="bold">Failed messages</Text>
          <Text fontSize="sm" color="admin.muted">
            Failed processing and uncertain outbound submissions appear here. A submission
            marked unknown may already have reached the recipient; reconcile it before any retry.
          </Text>
        </Box>
        <Button colorScheme="purple" backgroundColor="#88077b" onClick={load}>Refresh</Button>
      </Flex>
      {loading ? <Spinner size="xl" /> : rows.length === 0 ? (
        <Text color="admin.muted">Nothing dead-lettered. 🎉</Text>
      ) : (
        <Table variant="striped">
          <Thead backgroundColor="#88077b"><Tr>
            <Th color="white">When</Th><Th color="white">Phone</Th><Th color="white">Text</Th>
            <Th color="white">Status</Th><Th color="white">Attempts</Th><Th color="white">Error</Th><Th color="white">Action</Th>
          </Tr></Thead>
          <Tbody>
            {rows.map((r, i) => (
              <Tr key={r.id} backgroundColor={i % 2 === 0 ? "admin.surface" : "admin.selected"}>
                <Td whiteSpace="nowrap">{r.created_at ? new Date(r.created_at).toLocaleString() : "-"}</Td>
                <Td>{r.phone_number}</Td>
                <Td maxW="320px"><Text noOfLines={2}>{r.text || "-"}</Text></Td>
                <Td>{r.status === "submission_unknown" ? "Submission unknown" : "Failed"}</Td><Td><Badge colorScheme="red">{r.attempts}</Badge></Td>
                <Td maxW="240px"><Text noOfLines={2} fontSize="xs">{r.error || "-"}</Text></Td>
                <Td>{r.status === "submission_unknown" ? <Text fontSize="sm">Reconcile before retry</Text> : <Button size="sm" colorScheme="purple" onClick={() => requeue(r.id)}>Requeue</Button>}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};
export default DeadLetters;
